export const CAMPOS_ALTERAVEIS = [
  {
    "alteravel": false,
    "nomeCampo": "pgtoProcNr",
    "valor": null
  },
  {
    "alteravel": false,
    "nomeCampo": "pgtoNrIdDepositoCef",
    "valor": null
  },
  {
    "alteravel": false,
    "nomeCampo": "origemErro",
    "valor": "NÃO BANCO"
  },
  {
    "alteravel": true,
    "nomeCampo": "numeroProcessoRetificacao",
    "valor": null
  },
  {
    "alteravel": true,
    "nomeCampo": "ni",
    "valor": "02036483000100"
  },
  {
    "alteravel": true,
    "nomeCampo": "tipoNi",
    "valor": "J"
  },
  {
    "alteravel": true,
    "nomeCampo": "pgtoDtEncerraPerApu",
    "valor": new Date()
  },
  {
    "alteravel": false,
    "nomeCampo": "pgtoDtArrecadacao",
    "valor": new Date()
  },
  {
    "alteravel": true,
    "nomeCampo": "pgtoDtVencimento",
    "valor": new Date()
  },
  {
    "alteravel": true,
    "nomeCampo": "pgtoNrReferencia",
    "valor": "00000000008176000"
  },
  {
    "alteravel": true,
    "nomeCampo": "pgtoVlRecBrutAcum",
    "valor": null
  },
  {
    "alteravel": true,
    "nomeCampo": "pgtoPcRecBrut",
    "valor": null
  },
  {
    "alteravel": false,
    "nomeCampo": "codigoBancoCPS",
    "valor": "237"
  },
  {
    "alteravel": false,
    "nomeCampo": "codigoAgenciaCPS",
    "valor": "3245"
  },
  {
    "alteravel": true,
    "nomeCampo": "valoresReceita",
    "valor": null
  },
]